export const LOCAL_STORAGE_USER_KEY = "utente";
export const EVENT_COMMENTS = "eventComments";
export const EVENT_TESTIMONIANZE = "eventTestimonianze";
export const REMOVED_SEGNALAZIONI = "removedSegnalazioni";
export const PARTICIPATING_EVENTS = "participatingEvents";
export const SEGNALAZIONI = "segnalazioni";
export const CURRENT_SEGNALAZIONE_ID = "currentSegnalazioneId";

export const storageKeys = [
  LOCAL_STORAGE_USER_KEY,
  EVENT_COMMENTS,
  EVENT_TESTIMONIANZE,
  REMOVED_SEGNALAZIONI,
  SEGNALAZIONI,
  PARTICIPATING_EVENTS,
  CURRENT_SEGNALAZIONE_ID,
];
